import Vue from 'vue'

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('imgFilter', function (value, size) {
  if (!value || value.startsWith('data:image')) {
    return value
  }
  let oss = ''
  if (size) {
    if (value.indexOf('?') > -1) {
      oss = '&'
    } else {
      oss = '?'
    }
    oss += 'x-oss-process=image/resize,l_' + size
  }
  if (value.startsWith('http') && value.indexOf(process.env.VUE_APP_OSS_URL) === -1) {
    return value
  }
  return (value.startsWith('http') ? value : process.env.VUE_APP_OSS_URL + value) + oss
})

Vue.filter('substring', function (value, begin, end) {
  return value.substring(begin, end)
})



// WEBPACK FOOTER //
// ./src/utils/filter.js